const shopHomepage = {
  displayField: 'title',
  name: 'Shop Homepage',
  description: 'Shop Homepage ',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'slug',
      name: 'Slug',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'listOfficeMlsId',
      name: 'List Office MLS ID',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'seo',
      name: 'SEO',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'seoPage' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'navigation',
      name: 'Navigation',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'shopNavigation' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'heroHeader',
      name: 'HeroHeader',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      defaultValue: { 'en-US': 'Live your luxury.' },
      disabled: false,
      omitted: false
    },
    {
      id: 'searchHeroCarousel',
      name: 'SearchHeroCarousel',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'heroCarousel' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'lifestyleHeader',
      name: 'LifestyleHeader',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      defaultValue: { 'en-US': 'Follow your dream, home.' },
      disabled: false,
      omitted: false
    },
    {
      id: 'lifestyleBody',
      name: 'Lifestyle Body',
      type: 'RichText',
      localized: true,
      required: false,
      validations: [
        {
          enabledMarks: [ 'bold', 'italic', 'code' ],
          message: 'Only bold, italic, and code marks are allowed'
        },
        {
          enabledNodeTypes: [ 'entry-hyperlink', 'hyperlink' ],
          message: 'Only link to entry and link to Url nodes are allowed'
        },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'lifestyleCarousel',
      name: 'Lifestyle Carousel',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'lifestyleCarousel' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'lifestyleType',
      name: 'LifestyleType',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'lifestyleType' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'advisorPromoAdvisorId',
      name: 'Advisor Promo AdvisorId',
      type: 'Array',
      localized: false,
      required: false,
      validations: [ { size: { min: 1, max: 3 } } ],
      disabled: false,
      omitted: false,
      items: { type: 'Symbol', validations: [] }
    },
    {
      id: 'advisorsCustom',
      name: 'Custom Advisors',
      type: 'Array',
      localized: false,
      required: false,
      validations: [ { size: { min: 1, max: 3 } } ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'advisorCustom' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'advisorPromoHeader',
      name: 'Advisor Promo Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      defaultValue: { 'en-US': 'We’ll help you find your way. ' },
      disabled: false,
      omitted: false
    },
    {
      id: 'advisorPromoBody',
      name: 'Advisor Promo Body',
      type: 'RichText',
      localized: true,
      required: false,
      validations: [
        {
          enabledMarks: [ 'bold', 'italic' ],
          message: 'Only bold and italic marks are allowed'
        },
        { enabledNodeTypes: [], message: 'Nodes are not allowed' },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'statisticGroup',
      name: 'StatisticGroup',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'statisticGroup' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'newestListingsHeader',
      name: 'Newest Listings Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'blogHeader',
      name: 'Blog Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'neighborhoodsHeader',
      name: 'Neighborhoods Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'bigPictureCta',
      name: 'Big Picture CTA',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'bigPictureCta' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'storyContentNested',
      name: 'Story Content Nested',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'nestedTextImageBlock' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'featuredNeighborhoods',
      name: 'Featured Neighborhoods',
      type: 'Array',
      localized: false,
      required: false,
      validations: [ { size: { min: 1, max: 5 } } ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'neighborhoodSingle' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'dynamicContentBlocks',
      name: 'Dynamic Content Blocks',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [
          {
            linkContentType: [
              'wideTextImage',
              'WideStackedTextImageBlock',
              'StackedTextImageForm'
            ]
          }
        ],
        linkType: 'Entry'
      }
    },
    {
      id: 'footer',
      name: 'Footer',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'siteFooter' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    }
  ],
  metadata: {
    annotations: {
      ContentType: [
        {
          sys: {
            id: 'Contentful:AggregateRoot',
            type: 'Link',
            linkType: 'Annotation'
          }
        }
      ],
      ContentTypeField: {
        searchHeroCarousel: [
          {
            sys: {
              id: 'Contentful:AggregateComponent',
              type: 'Link',
              linkType: 'Annotation'
            }
          }
        ],
        statisticGroup: [
          {
            sys: {
              id: 'Contentful:AggregateComponent',
              type: 'Link',
              linkType: 'Annotation'
            }
          }
        ]
      }
    }
  },
  sys: {
    id: 'shopHomepage',
    version: 106,
    updatedAt: '2023-08-03T14:32:01.357Z'
  }
};
export default shopHomepage;